import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AnalyticsEvent } from '../../models/analytics-event.interface';
import { MicroMoments } from './models/micro-moments.interfaces';

@Component({
  selector: 'idp-micro-moments',
  templateUrl: './micro-moments.component.html',
  styleUrls: ['./micro-moments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MicroMomentsComponent {
  @Input() content: MicroMoments = {} as MicroMoments;
  @Output() microMomentClick = new EventEmitter<AnalyticsEvent>();

  display = true;

  constructor() {
    // Constructor intentionally empty
  }

  redirect(link: string) {
    // Emit analytics event
    const eventData = {
      id: this.content.id || 'micro_moment',
      name: this.content.title || 'Micro Moment',
      position: 1,
      link: link
    };

    this.microMomentClick.emit({
      eventName: 'micro_moment_click',
      eventData: JSON.stringify(eventData)
    });

    // Keep existing redirect functionality
    window.open(link, '_blank');
  }
}
